const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/styles/$slug.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/styles/$slug")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});